// Styles
import './pdp-product-details.scss';
import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { stargateCreateLink } from '../../scripts/components/stargate';
import { debounce } from 'lodash';

gsap.registerPlugin(ScrollTrigger);

const selectors = {
  section: '.pdp-product-details',
  tile: '.pdp-product-details__tile',
};

(function ($) {
  if (!window.dAgency) window.dAgency = {};
  window.dAgency.initPDPProductDetails = (section) => {
    if (section) {
      const tile = section.querySelector(selectors.tile);

      if (section.children.length) {
        var productScroller = ScrollTrigger.create({
          trigger: selectors.section,
          pin: selectors.tile,
          start: `top top`,
          end: `bottom bottom-=${window.innerHeight - tile.clientHeight}`,
          markers: false,
        });

        const scrollTriggerRefresh = debounce(() => {
          setTimeout(() => {
            productScroller.kill();
            ScrollTrigger.refresh();
            window.requestAnimationFrame(() => {
              productScroller = ScrollTrigger.create({
                trigger: selectors.section,
                pin: selectors.tile,
                start: `top top`,
                end: `bottom bottom-=${window.innerHeight - tile.clientHeight}`,
                markers: false,
              });
            });
          }, 1000);
        }, 500);
        window.addEventListener('resize', scrollTriggerRefresh);
      }
    }

    const productInfoSection = document.querySelector('.product-template');
    if (productInfoSection) {
      $(productInfoSection).on('variantChange', function (e) {
        const currentVariant = e.variant;
        if (window.dAgency && window.dAgency.productDetails) {
          const currentVariantDetails =
            window.dAgency.productDetails[currentVariant.id];

          stargateCreateLink(
            currentVariantDetails,
            document.querySelector(selectors.section),
          );
        }
      });
    }
  };

  if (document.readyState != 'loading') {
    [].forEach.call(document.querySelectorAll('.pdp-product-details'), (el) => {
      window.dAgency.initPDPProductDetails(el);
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      [].forEach.call(
        document.querySelectorAll('.pdp-product-details'),
        (el) => {
          window.dAgency.initPDPProductDetails(el);
        },
      );
    });
  }
})(window.jQuery);
